import { useEffect } from 'react';

// eslint-disable-next-line no-unused-vars, import/extensions
import MUIAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { ClassNames } from '@emotion/react';
import {
  useLocation,
} from 'react-router-dom';

import { LightGreen } from './Styles';
import CartBadge from './CartBadge';
import { platformPad } from './NavDrawer';

import reversedType from '../containers/img/market_2day_reversed_type.svg';

const appBarTheme = createMuiTheme({
  typography: {
    fontFamily: '"Open Sans",sans-serif',
    fontSize: 17,
  },
  palette: {
    primary: {
      light: '#cccccc',
      main: '#ffffff',
      dark: '#333333',
      contrastText: LightGreen,
    },
  },
});

const AppBar = ({
  expandAppBar,
  expandedAppBar,
  handleMenu,
}) => {
  const location = useLocation();
  useEffect(() => expandAppBar(undefined), [location]);
  return (
    <MuiThemeProvider theme={appBarTheme}>
      <ClassNames>
        {({ css }) => (
          <MUIAppBar position="sticky" elevation={0} classes={{ root: css(`padding-top: ${platformPad()} !important; @media print { display: none !important; }`) }}>
            <Toolbar classes={{ root: css('padding-left: 0px !important; padding-right: 0px !important; display: flex; justify-content: space-between;') }}>
              <IconButton
                aria-label="Menu"
                onClick={handleMenu}
                className="focus:outline-none"
              >
                <MenuIcon style={{ color: LightGreen }} />
              </IconButton>
              <img alt="" src={reversedType} style={{ height: '18px' }} />
              <CartBadge />
            </Toolbar>
            {expandedAppBar}
          </MUIAppBar>
        )}
      </ClassNames>
    </MuiThemeProvider>
  );
};

export default AppBar;
